import { Routes, Route, Navigate } from "react-router-dom";
import DocumentUpload from "./DocumentUpload";
import DocumentDetail from "./DocumentDetail";

export default function DocumentsRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="/clinops/sites" replace />} />
      <Route path="upload" element={<DocumentUpload />} />
      <Route path=":id" element={<DocumentDetail />} />
    </Routes>
  );
}
